import useTenant from '@/hooks/useTenant'
import Link, { useCountry } from '@/components/Link'
import { Button } from '@mui/material'
import { usePathname } from 'next/navigation'

const RequestAQuoteButton = () => {
  const tenant = useTenant()
  const countryCode = useCountry()
  const pathname = usePathname()

  if (!pathname?.includes('/office-catering/vendors')) return

  const requestAQuote = tenant.marketing?.links?.find(
    (l) => l.countryCode === countryCode.toLowerCase(),
  )?.requestAQuote

  if (!requestAQuote) return null

  return (
    <Link href={requestAQuote} passHref>
      <Button variant="contained" size="medium">
        Get a quote
      </Button>
    </Link>
  )
}

export default RequestAQuoteButton
